import { FileIconStyled } from './FileIconStyled';

export const SystemIcon = FileIconStyled({ iconOutSize: 50, iconSize: 32 });
